<template lang="pug">
v-card(flat).my-1.ev-card.links-input
  p.pa-2.d-flex.align-center
    v-icon.mr-2 mdi-link-variant
    span.subtitle.mr-8 Ссылки

    template(v-if="!readonly")
      ev-dialog(title="Добавить ссылку")
        template(#default="{ close }")
          links-input-create(@input="onLinkInput($event, close)")
        template(#activator="{ on, attrs }")
          v-btn(
            v-on="on"
            v-bind="attrs"
            color="accent"
            fab
            small
          )
            v-icon mdi-plus

  template(v-if="links.length")
    v-list(
      dense
      two-line
    )
      v-scroll-y-transition(group leave-absolute)
        template(v-for="item in links")
          v-list-item(:key="item.src")
            v-list-item-avatar
              v-icon mdi-link-box
            v-list-item-content
              v-list-item-title {{ item.description }}
              v-list-item-subtitle
                a(
                  :href="item.src"
                  target="_blank"
                ) {{ item.src }}
            template(v-if="!readonly")
              v-list-item-icon
                v-btn(
                  fab
                  small
                  text
                  color="error"
                  @click="remove(item)"
                )
                  v-icon mdi-close
</template>

<script>
import LinksInputCreate from './LinksInputCreate.vue';

export default {
  name: 'LinksInput',
  components: {
    LinksInputCreate,
  },
  props: {
    value: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    links: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    remove(item) {
      this.links = this.links.filter((i) => i !== item);
      this.$emit('deleteLink', item.id);
    },
    onLinkInput(value, callback) {
      this.links.push(value);
      callback();
    },
  },
};
</script>
